import { createSlice } from '@reduxjs/toolkit';

const chatSlice = createSlice({
    name: 'chat',
    initialState: { unreadCount: 0 },
    reducers: {
        setChatUnreadCount: (state, action) => { state.unreadCount = action.payload || 0; },
    },
});

export const { setChatUnreadCount } = chatSlice.actions;
export const selectChatUnreadCount = (s) => s.chat.unreadCount;
export default chatSlice.reducer;
